import styled from 'styled-components'

const loadMoreBlack = '#101115'
const dropdownBorder = '#DDE2E5'
const dateGrey = '#DDE2E5'

export const Component = styled.div`
  width: 100%;
`

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-direction: row;
    align-items: flex-start;
  }
`

export const Sidebar = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    width: 37.3rem;
    flex: 0 0 37.3rem;
  }
`

interface TabButtonProps {
  $active: boolean
}
export const TabButton = styled.button<TabButtonProps>`
  width: 100%;
  height: 4.8rem;
  border: 0;
  border-radius: 0.4rem;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.6rem;
  font-weight: 500;
  text-align: center;
  transition: 0.2s ease all;
  background: ${(props) => (props.$active ? props.theme.primaryGreenDarkMode : props.theme.tertiaryBlack)};
  color: ${(props) => (props.$active ? '#000000' : props.theme.primaryWhite)};
  &:hover,
  &:focus {
    opacity: 0.9;
  }
`

export const Content = styled.div`
  width: 100%;
  min-width: 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex: 1 1 auto;
  }
`

export const Intro = styled.p`
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.applyOpacity(theme.primaryWhite, 0.89)};
  margin-bottom: 1.6rem;
`

export const FilterBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.6rem;
  padding: 1.6rem;
  border-radius: 0.6rem;
  background: ${({ theme }) => theme.tertiaryBlack};
  margin-bottom: 1.6rem;
`

export const FilterLabel = styled.span`
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.3rem;
  font-weight: 500;
  color: ${({ theme }) => theme.applyOpacity(theme.primaryWhite, 0.89)};
`

interface SelectWrapperProps {
  $width: string
}
export const SelectWrapper = styled.div<SelectWrapperProps>`
  position: relative;
  width: ${(props) => props.$width};
  max-width: 100%;
`

export const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  height: 4.8rem;
  padding: 0 4rem 0 1.6rem;
  border: 1px solid ${dropdownBorder};
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.primaryWhite};
  color: ${({ theme }) => theme.secondaryBlack};
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.5rem;
  font-weight: 400;
  cursor: pointer;
`

export const Caret = styled.svg`
  position: absolute;
  top: 50%;
  right: 1.2rem;
  transform: translateY(-50%);
  width: 2rem;
  height: 2rem;
  pointer-events: none;
  fill: ${({ theme }) => theme.secondaryBlack};
`

export const FileList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
`

export const FileRow = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.secondaryBlack};
`

export const FileLink = styled.a`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  padding: 1.6rem;
  text-decoration: none;
  transition: 0.2s ease background;
  &:hover,
  &:focus {
    background: ${({ theme }) => theme.applyOpacity(theme.primaryWhite, 0.04)};
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    flex-wrap: nowrap;
  }
`

export const FileTitle = styled.span`
  order: 1;
  flex: 1 1 auto;
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.7rem;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryWhite};
`

export const FileDate = styled.span`
  order: 3;
  flex-basis: 100%;
  margin-top: 0.8rem;
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.3rem;
  font-weight: 500;
  color: ${dateGrey};
  text-align: left;
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    order: 2;
    flex-basis: auto;
    margin-top: 0;
    margin-left: auto;
    text-align: right;
  }
`

export const DocIcon = styled.svg`
  order: 2;
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  margin-left: 0.8rem;
  fill: ${({ theme }) => theme.primaryWhite};
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    order: 3;
  }
`

export const Message = styled.p`
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.5rem;
  font-weight: 400;
  color: ${({ theme }) => theme.applyOpacity(theme.primaryWhite, 0.7)};
  padding: 1.6rem;
`

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.6rem;
`

export const LoadMore = styled.button`
  width: 100%;
  height: 4.8rem;
  border: 0;
  border-radius: 0.4rem;
  cursor: pointer;
  font-family: ${({ theme }) => theme.fontName};
  font-size: 1.6rem;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryWhite};
  background: ${loadMoreBlack};
  transition: 0.2s ease opacity;
  &:hover,
  &:focus {
    opacity: 0.85;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.medium}) {
    width: 18.5rem;
  }
`
